import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state'; import { Action, Selector, State, StateContext } from '@ngxs/store';
import { NotificationTemplateCreate, NotificationTemplateDelete, NotificationTemplateRefresh, NotificationTemplateRefreshByID, NotificationTemplateUpdate } from './notification-template.action';
import { NotificationTemplate } from 'src/app/components/catalogs/notifications/services/notification-template';
import { CatalogService } from '../../catalog-service';
import { Catalog } from 'src/app/common/enumerations/enumerations';

export class NotificationTemplateStateModel {
  data: NotificationTemplate[] = [];
}

@State<NotificationTemplateStateModel>({
  name: 'NotificationTemplates',
  defaults: {
    data: []
  }
})

@Injectable()
export class NotificationTemplateState extends BaseState {
  constructor(
    protected override injector: Injector,
    private service: CatalogService

  ) {
    super(injector);
  }

  @Selector()
  static read(state: NotificationTemplateStateModel) {
    return state.data;
  }

  @Action(NotificationTemplateRefresh)
  refresh({ patchState }: StateContext<NotificationTemplateStateModel>) {
    this.service.GetJoinCreated(Catalog.EmailNotificationCatalog, false).subscribe(
      data => {
        patchState({ data: data.notificationTemplates })
      },
      error => console.error(error)
    );
  }

  @Action(NotificationTemplateRefreshByID)
  refreshByID({ getState, patchState }: StateContext<NotificationTemplateStateModel>, { id }: NotificationTemplateRefreshByID) {
    this.service.GetPendingCatalogById(id, Catalog.EmailNotificationCatalog).subscribe(data => {
      const state = getState();
      const index = state.data.map(x => x.id).indexOf(id);

      if (index >= 0) {
        state.data.splice(index, 1);
      }
      if (data.notificationTemplate)
        patchState({
          data: [...state.data, data.notificationTemplate]
        });
    },
      error => console.error(error)
    );
  }

  @Action(NotificationTemplateCreate)
  create({ getState, patchState }: StateContext<NotificationTemplateStateModel>, { item }: NotificationTemplateCreate) {
    patchState({
      data: [...getState().data, item]
    });
  }

  @Action(NotificationTemplateUpdate)
  update({ getState, patchState }: StateContext<NotificationTemplateStateModel>, { id, item }: NotificationTemplateUpdate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(id);

    if (index >= 0) {
      state.data.splice(index, 1);
      patchState({
        data: [...state.data, item]
      });
    }
  }

  @Action(NotificationTemplateDelete)
  delete({ getState, patchState }: StateContext<NotificationTemplateStateModel>, { id }: NotificationTemplateDelete) {
    patchState({
      data: getState().data.filter(x => x.id != id)
    });
  }

}
